import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {
    name: '',
    email: '',
    phone: '',
    address: '',
    gst_number: '',
    contact_type: '',
    order_date: new Date(),
    delivery_date: null,
    advance_amount: '0',
    pending: '0',
    payment_method: '',
    order_type: 'quotation',
    branch_id: '',
    delivery_address: '',
    packing_charges: '0',
    salesman_name: '',
    discount_percentage: '',
    delivery_type: '',
    payment_date: new Date(),
    invoice_number: '',
    branch_code: '',
    notes: '',
    customise_name: '',
    cake_quantity: '1',
    status: 'order_placed',
  },
  errors: {},
  sameAsAddress: true,
  customers: [],
  branches: [],
  selectedCustomerId: '',
  selectedCustomer: null,
  mode: '',
  submitting: false,
   totals: { subtotal: 0, taxAmount: 0, total: 0 },
  invoiceStatus: { exists: null, message: '' },
  openModal: false,
  openAdvance: false,
  openOrder: false,
  openDelivery: false,
  loading: false,
};

const cakeOrderSlice = createSlice({
  name: 'cakeOrder',
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setSameAsAddress: (state, action) => {
      state.sameAsAddress = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    setSelectedCustomerId: (state, action) => {
      state.selectedCustomerId = action.payload;
    },
    // setSelectedCustomer: (state, action) => {
    //   state.selectedCustomer = action.payload;
    // },

    setSelectedCustomer: (state, action) => {
  state.selectedCustomer = action.payload;
  if (action.payload) {
    state.formData = {
      ...state.formData,
      customer_id: action.payload.id?.toString() || '',
      name: action.payload.name || '',
      email: action.payload.email || '',
      phone: action.payload.phone || '',
      address: action.payload.address || '',
      gst_number: action.payload.gst_number || '',
      contact_type: action.payload.contact_type || '',
      delivery_address: state.sameAsAddress
        ? action.payload.address || ''
        : action.payload.delivery_address || state.formData.delivery_address,
    };
    state.errors.customer_id = '';
  }
},
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setSubmitting: (state, action) => {
      state.submitting = action.payload;
    },
    setTotals: (state, action) => {
      state.totals = action.payload;
    },
    setInvoiceStatus: (state, action) => {
      state.invoiceStatus = action.payload;
    },
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    setOpenAdvance: (state, action) => {
      state.openAdvance = action.payload;
    },
    setOpenOrder: (state, action) => {
      state.openOrder = action.payload;
    },
    setOpenDelivery: (state, action) => {
      state.openDelivery = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
      state.selectedCustomerId = '';
      state.selectedCustomer = null;
      state.mode = '';
      state.openModal = false;
    },
  },
});

export const {
  setFormData,
  setErrors,
  setSameAsAddress,
  setCustomers,
  setBranches,
  setSelectedCustomerId,
  setSelectedCustomer,
  setMode,
  setSubmitting,
  setTotals,
  setInvoiceStatus,
  setOpenModal,
  setOpenAdvance,
  setOpenOrder,
  setOpenDelivery,
  setLoading,
  resetForm,
} = cakeOrderSlice.actions;

export default cakeOrderSlice.reducer;